import { CompanyContactType } from '@api';
import { ComboboxItem } from '@mantine/core';

export const getContactPersonOptions = (
  data: CompanyContactType[]
): ComboboxItem[] =>
  data.map((contactPerson, index) => ({
    value: index.toString(),
    label: `${contactPerson.personName} | ${contactPerson.companyName}`,
  }));
